import { UpgradeSdaiAction } from '../types'
import { migrationActionsConfig } from '@/config/contracts-generated'
import { getContractAddress } from '@/domain/hooks/useContractAddress'
import { getBalancesQueryKeyPrefix } from '@/domain/wallet/getBalancesQueryKeyPrefix'
import { allowanceQueryKey } from '@/features/actions/flavours/approve/logic/query'
import { ensureConfigTypes } from '@/features/actions/logic/transactions/useWrite'
import { ActionConfig, ActionContext } from '@/features/actions/logic/types'

export function createUpgradeSdaiActionConfig(action: UpgradeSdaiAction, context: ActionContext): ActionConfig {
  const { account, chainId } = context
  const upgradeAmount = action.sdai.toBigInt(action.amount)

  return {
    getWriteConfig: () => {
      return ensureConfigTypes({
        address: getContractAddress(migrationActionsConfig.address, chainId),
        abi: migrationActionsConfig.abi,
        functionName: 'migrateSDAISharesToSUSDS',
        args: [account, upgradeAmount],
      })
    },

    invalidates: () => {
      return [
        allowanceQueryKey({
          token: action.sdai.address,
          spender: getContractAddress(migrationActionsConfig.address, chainId),
          account,
          chainId,
        }),
        getBalancesQueryKeyPrefix({ chainId, account }),
      ]
    },
  }
}
